import {
  getPlayerTypesBySportId,
  getSoccerSport,
  getTeamOfficialTypesBySportId,
} from '@sportninja/common/selectors/types'
import { connect } from 'react-redux'

import { GameRosterView } from 'src/features/game/gameRoster'

// Gate only — the roster lives in src/features/game/gameRoster.
const GameRoster = ({
  gameId,
  rosterId,
  isGameStarted = false,
  isGameCompleted = false,
  isPlaceholder = false,
  isEmptyRoster = false,
  isGenericGame = false,
  canViewAttendanceInfo = false,
  // Redux
  isInFrame = false,
  isSoccer = false,
  playerTypes = [],
  teamOfficialTypes = [],
}) => (
  <GameRosterView
    gameId={gameId}
    rosterId={rosterId}
    isGameStarted={!!isGameStarted}
    isGameCompleted={!!isGameCompleted}
    isPlaceholder={isPlaceholder}
    isEmptyRoster={isEmptyRoster}
    isGenericGame={isGenericGame}
    isSoccer={isSoccer}
    canViewAttendanceInfo={canViewAttendanceInfo}
    isInFrame={!!isInFrame}
    playerTypes={playerTypes}
    teamOfficialTypes={teamOfficialTypes}
  />
)

const mapStateToProps = (state, { sportId }) => {
  return {
    isInFrame: state.auth.inFrame,
    isSoccer: !!sportId && getSoccerSport(state)?.id === sportId,
    playerTypes: getPlayerTypesBySportId(state, sportId),
    teamOfficialTypes: getTeamOfficialTypesBySportId(state, sportId),
  }
}

export default connect(mapStateToProps)(GameRoster)
